<script>
  import { user } from "../../stores/user";
  import { user_cliente_api, user_cliente_filtro } from "../../stores/user-cliente";
  import CardContent from "../CardContent.svelte";
  import Acciones from "./Acciones.svelte";
  import Api from "./Api.svelte";
  import Contratos from "./Contratos.svelte";
  import Datos from "./Datos.svelte";
  import Filtros from "./Filtros.svelte";
  import Masivos from "./Masivos.svelte";
  import Permisos from "./Permisos.svelte";
  //import Planilla from "./Planilla.svelte"
  import RedesAutorizadas from "./RedesAutorizadas.svelte";

  export let id;
</script>

{#if $user}
  <div class="row g-2">
    <div class="col-12 col-lg-6">
      <CardContent title="Datos del usuario">
        <Datos id_usuario={id} />
      </CardContent>
      <div class="mb-2" />
      <CardContent title="Redes autorizadas">
        <RedesAutorizadas id_usuario={id} />
      </CardContent>
      <div class="mb-2" />
      <!-- <CardContent title="Descarga de planilla">
        <Planilla id_usuario={id} />
      </CardContent> -->
    </div>
    <div class="col-12 col-lg-6">
      <CardContent title="Contratos">
        <Contratos id_usuario={id} />
      </CardContent>
      <!-- <div class="mb-2" />
      <CardContent title="Masivos">
        <Masivos id_usuario={id} />
      </CardContent>
      {#if $user_cliente_filtro.id_usuario != 0}
        <div class="mb-2" />
        <CardContent title="Filtros">
          <Filtros id_usuario={id} />
        </CardContent>
      {/if} -->
      <div class="mb-2" />
      <CardContent title="Permisos">
        <Permisos id_usuario={id} />
      </CardContent>
      {#if $user_cliente_api.id_usuario != 0}
        <div class="mb-2" />
        <CardContent title="Api">
          <Api id_usuario={id} />
        </CardContent>
      {/if}
      <div class="mb-2" />
      <CardContent title="Últimas acciones del usuario">
        <Acciones id_usuario={id} />
      </CardContent>
    </div>
  </div>
{/if}
